import { IStatusConfig } from '../../../components/StatusBadge'
import { TBulkModality } from '../../../services/CoursesService/interfaces'

/**
 * Modalidade de preço. Rótulo e cor no mesmo registro, na forma que o `<StatusBadge>` lê — eram
 * dois `Record` paralelos.
 */
export const BULK_MODALITY: Record<TBulkModality, IStatusConfig> = {
  in_person: { label: 'Presencial', colorScheme: 'orange' },
  live_online: { label: 'Online ao Vivo', colorScheme: 'green' },
  recorded: { label: 'Vídeo-aula', colorScheme: 'blue' }
}
